import { createRequest, type DmCoreRequestConfig } from './http/request'
import { createSpaceOperatorApi, type SpaceOperatorApi } from './spaceOperator/spaceOperatorApi'

export interface DmCoreClientOptions extends DmCoreRequestConfig {
  tenantUuid: string
  deviceUuid: string
}

export interface DmCoreClient {
  spaceOperator: SpaceOperatorApi
}

export const createDmCoreClient = (options: DmCoreClientOptions): DmCoreClient => {
  const { tenantUuid, deviceUuid, ...requestConfig } = options
  const request = createRequest(requestConfig)

  return {
    spaceOperator: createSpaceOperatorApi(request, { tenantUuid, deviceUuid })
  }
}
